import gql from 'graphql-tag';

export default gql`
  query LatestProductions($limit: Int) {
    latestProductions(limit: $limit) {
      premium {
        id
        slug
        name
        year
        type
        saleOrRent
        sets
        costumes
        titles
        props
        orchestration
        isDigital
        images {
          url
          thumbUrl
        }
        features {
          id
          type
          name
          value
        }
        owner {
          id
          name
          slug
          plan
        }
        createdAt
      }
      free {
        id
        slug
        name
        year
        type
        isDigital
        images {
          url
          thumbUrl
        }
        owner {
          id
          name
          slug
          plan
        }
        createdAt
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/LatestProductions.js